import { MenuItem, Popover, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CountryCodesList } from './CountryCodesList';
import SearchBar from '../../../Components/SearchBar';
import { AppColors } from '../../../Utils/helper/AppColors';
import { filterBySearch } from '../../../Utils/helper/commonUtils';
import { MdArrowDropDown } from 'react-icons/md';
import ReactCountryFlag from 'react-country-flag';

export default function CountryCode({ countryCode, setCountryCode , setCountryCodeAllInfo ,isNeeded = false}) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [search, setSearch] = useState('');

	const handleClose = () => {
		setAnchorEl(null);
		setSearch('');
	};


	const getCurrentCountryCode = () => {

		const country = CountryCodesList.find(c => c.code === countryCode?.code);
		return country ? country.code : '';
	};

	useEffect(() => {
		if (countryCode) {
			console.log('countryCode inside useeffet', countryCode);
			const found = CountryCodesList.find(c => c.code === countryCode?.code);
			console.log('cc', countryCode);
			console.log('found', found);
			if (found) {
				setCountryCodeAllInfo?.(found);
			}
		}
	}, [JSON.stringify(countryCode)]);
	

	return (
		<>
			<Stack
				onClick={(e) => setAnchorEl(e.currentTarget)}
				sx={{ cursor: 'pointer' }}
				p={1}
				mr={1}
				ml={-1.6}
				borderRadius="inherit"
				border={isNeeded ? '2px solid red' : 'none'}
				bgcolor='#ffffff'
				direction="row"
				alignItems="center"
				gap={0.5}
			>
				{countryCode?.dial_code && (
					<ReactCountryFlag
						countryCode={getCurrentCountryCode()}
						svg
						style={{
							width: '1.5em',
							height: '1.5em',
						}}
					/>
				)}
				<Typography variant="subtitle2" fontSize={15} color={AppColors.TEXT_PRIMARY}>
					{countryCode?.dial_code}
				</Typography>
				<MdArrowDropDown size={22} />
			</Stack>

			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<Stack sx={{ '& .MuiTypography-root': { textAlign: 'left' } }} p={1} gap={0.5}>
					<SearchBar search={search} setSearch={setSearch} placeholder="Search Country" />
					<Stack width={380} maxHeight={400} overflow="auto" justifyContent="flex-start" alignItems="flex-start">
						{filterBySearch(CountryCodesList, search, ['name', 'dial_code'])?.map((i, index) => (
							<MenuItem
								key={index}
								sx={{ gap: 1, width: '100%', justifyContent: 'flex-start', p: 0.5, borderRadius: 1, px: 1.5 }}
								onClick={() => {
									    console.log('Selected country:', i); // Log the selected country object

									setCountryCode(i);
									handleClose();
								}}
							>
								<ReactCountryFlag
									countryCode={i.code}
									svg
									style={{
										width: '1.5em',
										height: '1.5em',
									}}
								/>
								<Typography variant="subtitle2">{i.name}</Typography>
								<Typography variant="subtitle1">{i.dial_code}</Typography>
							</MenuItem>
						))}
					</Stack>
				</Stack>
			</Popover>
		</>
	);
}
